import React, { useEffect, useRef } from "react";

// Keep the original shortcut component (and its subscriptions) mounted in the drawer.
export default function PhoneShortcut({ label, children }) {
  const ref = useRef(null);
  useEffect(() => {
    const button = ref.current && ref.current.querySelector("button");
    if (button) button.setAttribute("aria-label", label);
  }, [label]);
  return (
    <div ref={ref} data-phone-shortcut style={{ "--phone-shortcut-label": JSON.stringify(label) }}>
      {children}
    </div>
  );
}
